<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="banner">
      <img src="../../assets/img/sh_banner.png" class="img_banner" alt />
      <div class="banner_1">
        <div class="banner_left">
          <img src="../../assets/img/guanyu/sh_logo.png" alt />
          <p>赋能商会信息化建设助力民营经济发展</p>
        </div>
        <div class="banner_right">
          <div class="banner_right_1">
            <p class="banner_right_p">欢迎登录新商会系统</p>
            <div class="login">
              <div class="login_1">
                <img src="../../assets/img/sh_login_icon_user.png" alt />
                <input type="text" placeholder="请输入账号" />
              </div>
              <div class="login_1">
                <img src="../../assets/img/sh_login_icon_password.png" alt />
                <input type="text" placeholder="请输入密码" />
              </div>
              <div class="login_2">
                <img src="../../assets/img/sh_login_icon_tel.png" alt />
                <input type="text" placeholder="请输入手机号" />
                <p>
                  <a href="#">获取验证码</a>
                </p>
              </div>
              <div class="login_1">
                <img src="../../assets/img/sh_login_icon_code.png" alt />
                <input type="text" placeholder="请输入验证码" />
              </div>
              <div class="login_3">
                <a href="#">登录</a>
              </div>
            </div>
          </div>
          <div class="banner_right_2">
            <p>还不是入驻商会？<a href="#">马上入驻</a></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="cent">
      <div class="cent_1">
        <h1>帮助商会解决四大痛点问题</h1>
        <ul class="cent_ul">
          <li class="cent_li" :style="cent_li" style="margin:0;">
            <div class="kong"></div>
            <p class="cent_p">会员多，活跃度低</p>
            <p>没有专业的信息化 会员管理系统</p>
          </li>
          <li class="cent_li1" :style="cent_li1">
            <div class="kong"></div>
            <p class="cent_p">会员吸纳困难</p>
            <p>会员吸纳渠道少</p>
          </li>
          <li class="cent_li2" :style="cent_li2">
            <div class="kong"></div>
            <p class="cent_p">花销多，收入难</p>
            <p>商会运营成本高 收入少</p>
          </li>
          <li class="cent_li3" :style="cent_li3">
            <div class="kong"></div>
            <p class="cent_p">会员服务难</p>
            <p>会员服务创新 不知从何入手</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="content">
      <div class="content_1">
        <img src="../../assets/img/sh_img_system.png" class="img_content" alt />
        <h1>新商会系统</h1>
        <div class="content_cent">
          <p class="content_cent_p">商会免费使用，并获取会员在平台消费的5%服务佣金,帮助商会实现对会员的吸纳管理、内容发布、消息互动、活动通知、数据分析等</p>
          <div class="content_cent1">
            <ul>
              <li>会员 管理</li>
              <li>活动 消息</li>
              <li>官网 管理</li>
              <li>增加 收入</li>
              <p></p>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="content1">
      <div class="content1_1">
        <div class="content1_one">
          <h1>预期收益</h1>
          <p class="content1_one_p">
            商会获取会员在平台消费订单额
            <span>5%</span>的服务费
          </p>
          <ul class="content1_one_ul">
            <li>商会企业数量（家）</li>
            <li>产生服务占比（年）</li>
            <li>平均消费额度（元/年）</li>
            <li>总收益（元/年）</li>
          </ul>
          <div class="content1_one_nive">
            <ul>
              <li>200</li>
              <li>50%</li>
              <li>20,000.00</li>
              <li style="color:#F7681E;">100,000.00</li>
            </ul>
          </div>
          <div class="content1_one_nive1">
            <ul>
              <li>400</li>
              <li>50%</li>
              <li>20,000.00</li>
              <li style="color:#F7681E;">200,000.00</li>
            </ul>
          </div>
          <div class="content1_one_nive">
            <ul>
              <li>200</li>
              <li>50%</li>
              <li>20,000.00</li>
              <li style="color:#F7681E;">100,000.00</li>
            </ul>
          </div>
          <div class="content1_one_nive1">
            <ul>
              <li>400</li>
              <li>50%</li>
              <li>20,000.00</li>
              <li style="color:#F7681E;">200,000.00</li>
            </ul>
          </div>
          <p class="content1_one_p1">商会企业数量 * 产生服务占比 * 平均每年消费额 * 5% = 商会每年总收益</p>
        </div>
        <div class="content1_one">
          <h1>商会入驻流程</h1>
          <div class="content_two">
            <ul>
              <li>
                <img src="../../assets/img/sh_icon_step01.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_step02.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_step03.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_step04.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_step05.png" alt />
              </li>
            </ul>
          </div>
          <div class="content_two_1">
            <ul>
              <li style="margin:0">
                <p>申请入驻</p>
                <p style="font-size:14px;color:#666666">提交商会资质</p>
              </li>
              <li>
                <p>会员管理</p>
                <p style="font-size:14px;color:#666666">导入会员信息进行 会员管理服务</p>
              </li>
              <li>
                <p>官网维护</p>
                <p style="font-size:14px;color:#666666">维护商会资讯及 新闻等信息</p>
              </li>
              <li>
                <p>程序推广</p>
                <p style="font-size:14px;color:#666666">将程序推广至企业会员 为会员提供服务</p>
              </li>
              <li>
                <p>提取收益 吸纳会员</p>
                <p style="font-size:14px;color:#666666">会员在线服务消费的5% 为商会收益</p>
              </li>
            </ul>
          </div>
          <div class="content_two_2">
            <img src="../../assets/img/sh_bg_apply.png" alt />
            <p>使用新商会系统，享受商会会员管理服务</p>
            <p style="font-size:16px;" class="content_two_2p">
              <a href="#">申请使用</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      cent_li: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question01.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li1: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question02.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li2: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question03.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li3: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question04.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      }
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 590px;
  position: relative;
}

.img_banner {
  width: 100%;
  height: 100%;
}

.banner_1 {
  width: 1200px;
  height: 560px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.banner_left {
  width: 373px;
  height: auto;
  float: left;
}

.banner_left img {
  padding: 39px 0;
  margin-bottom: 50px;
}

.banner_left p {
  font-size: 40px;
  color: #fff;
  line-height: 60px;
}

.banner_right {
  width: 370px;
  height: auto;
  float: right;
}

.banner_right_1 {
  width: 100%;
  height: 370px;
  margin-top: 80px;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 20px;
}

/* 内容 */
.cent {
  width: 100%;
  height: auto;
  background: #f8faff;
  overflow: hidden;
}

.cent_1 {
  width: 1200px;
  height: 434px;
  margin: 0 auto;
}

.cent_1 h1,
.content_1 h1 {
  text-align: center;
  margin-top: 95px;
  margin-bottom: 80px;
}

.cent_ul li {
  width: 144px;
  height: 170px;
  margin-left: 205px;
  float: left;
}

.cent_ul li p {
  line-height: 23px;
}

.cent_ul li p:last-child {
  text-align: center;
  font-size: 14px;
  color: #666666;
}

.cent_p {
  color: #222222;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.kong {
  width: 100%;
  height: 99px;
}

.content {
  width: 100%;
  height: auto;
  margin-bottom: 144px;
}

.content_1 {
  width: 1200px;
  height: 828px;
  margin: 0 auto;
  position: relative;
}

.content_cent {
  width: 450px;
  height: auto;
  float: right;
  margin-right: 0px;
  margin-top: 150px;
}

.content_cent_p {
  width: 350px;
  color: #222;
  font-size: 14px;
  margin-bottom: 40px;
}

.content_cent1 {
  width: 100%;
  height: 194px;
  border-top: 1px solid #e4e4e4;
}

.content_cent1 ul {
  margin-top: 40px;
}

.content_cent1 ul li {
  width: 36px;
  height: 55px;
  float: left;
  margin: 0 0 0 60px;
  border-bottom: 2px solid #007bff;
  font-size: 18px;
  font-weight: 600;
}

.content_cent1 ul li:first-child {
  margin: 0;
}

.img_content {
  position: absolute;
  bottom: 0;
  left: -50%;
  margin-left: 200px;
}

.content1 {
  width: 100%;
  height: auto;
}

.content1_1 {
  width: 1200px;
  height: 1100px;
  margin: 0 auto;
}

.content1_one {
  width: 100%;
  height: 380px;
  margin-bottom: 144px;
}

.content1_one h1 {
  text-align: center;
  margin-bottom: 22px;
}

.content1_one_p {
  text-align: center;
  font-size: 14px;
  color: #222;
  margin-bottom: 60px;
}

.content1_one_p span {
  color: #f7681e;
}

.content1_one_ul {
  width: 100%;
  height: auto;
  display: flex;
}

.content1_one_ul li {
  width: 300px;
  height: 50px;
  border-bottom: 2px solid #008cff;
  text-align: center;
  line-height: 50px;
}

.content1_one_nive {
  width: 100%;
  height: 44px;
}

.content1_one_nive ul {
  display: flex;
}

.content1_one_nive ul li {
  width: 300px;
  text-align: center;
  line-height: 44px;
}

.content1_one_nive1 {
  width: 100%;
  height: 44px;
  background: #ecf0fb;
}

.content1_one_nive1 ul {
  display: flex;
}

.content1_one_nive1 ul li {
  width: 300px;
  text-align: center;
  line-height: 44px;
}

.content1_one_p1 {
  color: #999999;
  font-size: 14px;
  padding: 20px 0;
  text-align: center;
}

.content_two {
  width: 1200px;
  height: 54px;
  margin: 61px auto;
  margin-bottom: 27px;
}

.content_two ul li {
  float: left;
  padding: 0 0 0 40px;
  line-height: 54px;
}

.content_two_1 {
  width: 100%;
  height: 60px;
  margin-bottom: 59px;
}

.content_two_1 ul {
  display: flex;
}

.content_two_1 ul li {
  width: 20%;
  height: 18px;
  text-align: center;
  margin-left: 120px;
}

.content_two_1 ul li p {
  width: 150px;
  line-height: 22px;
}

.content_two_2 {
  width: 1200px;
  height: 144px;
  position: relative;
  overflow: hidden;
}

.content_two_2 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content_two_2 p {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}

.content_two_2p {
  width: 150px;
  height: 44px;
  background: #fff;
  margin: 0 auto;
  color: #007bff;
}

.content_two_2p a {
  color: #007bff;
  line-height: 44px;
}

.banner_right_p {
  padding: 20px 24px;
  color: #0055b0;
  font-size: 18px;
}

.input {
  width: 322px;
  height: 40px;
  margin: 0 24px;
}

.login {
  width: 322px;
  height: auto;
  margin: 0 auto;
}

.login_1 {
  width: 100%;
  height: 40px;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  margin-bottom: 20px;
}

.login_1 img {
  padding: 10px 11px;
  float: left;
}

.login_1 input {
  width: 250px;
  height: 40px;
  outline: none;
  border: 0;
}

.login_2 {
  width: 100%;
  height: 40px;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  margin-bottom: 20px;
}

.login_2 img {
  padding: 10px 11px;
  float: left;
}

.login_2 input {
  width: 186px;
  height: 40px;
  outline: none;
  border: 0;
  border-right: 1px solid #e4e4e4;
}

.login_2 p {
  width: 90px;
  float: right;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
}

.login_2 p a {
  color: #007bff;
}

.login_3 {
  width: 100%;
  height: 40px;
  background: #007bff;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}

.login_3 a {
  line-height: 40px;
  color: #fff;
}

.banner_right_2 {
  width: 251px;
  height: 30px;
  background: rgba(4, 4 , 15, 1);
  opacity: 0.74;
  border-radius: 15px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
}

.banner_right_2 a{
  color: #FFAB1D;
}
</style>



// WEBPACK FOOTER //
// src/view/Jiejue/Jiejue.vue